var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"membership-view"},[_c('TabComponent',{attrs:{"tabs":_vm.tabs,"title":"Membership"},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var tab = ref.tab;
return [_c(tab.component,{tag:"component"})]}}])}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }